import * as yup from "yup";
import stripHtml from "../../../utils/StripHtml";

export const schema = yup.object().shape({
  title: yup.string().required().min(3).max(255),
  content: yup
    .string()
    .required("Conteúdo é obrigatório")
    .test("hasText", "Conteúdo é obrigatório", (v) => stripHtml(v).length > 0)
    .test(
      "minWords",
      "Escreva pelo menos 3 palavras",
      (v) => stripHtml(v).split(/\s+/).filter(Boolean).length >= 3
    ),
  content_ia: yup.string().optional(),
  category_id: yup.number().required().moreThan(0),
  section_id: yup.number().notRequired(),
  subsection_id: yup.number().notRequired(),
  prompt_article: yup.string().notRequired().max(10000),
  is_file: yup.boolean().required(),
  is_internal: yup.boolean().required(),
  model_name: yup.string().notRequired(),
  list_file: yup.array().when("is_file", {
    is: true,
    then: (schema) => schema.required("Arquivo é obrigatório"),
    otherwise: (schema) => schema.notRequired(),
  }),
  list_prompt: yup.array().when("is_file", {
    is: true,
    then: (schema) => schema.required("Prompt de Filtros é obrigatório"),
    otherwise: (schema) => schema.notRequired(),
  }),
  related_articles: yup.array().of(yup.number().optional()).optional(),
  access_profile_articles: yup.array().of(yup.number().optional()).optional(),
  tags: yup.array().of(yup.number().optional()).optional(),
});
